const REFERRAL_CODE_KEY = 'referral_code';

export const getReferralCode = () => {
  const referralCode = window.localStorage.getItem(REFERRAL_CODE_KEY);
  if (!referralCode) return null;

  return referralCode;
};

export const setReferralCode = (referralCode: string) => {
  window.localStorage.setItem(REFERRAL_CODE_KEY, referralCode);
};

export const unsetReferralCode = () => {
  window.localStorage.removeItem(REFERRAL_CODE_KEY);
};
